import { createContext, useContext } from 'react';
import type { LiquidEngine } from '../../utils/liquidEngine';
import type { ChatState } from './chatProvider';
import type { DashboardState } from './dashboardProvider';
import type { ModalState } from './modalProvider';
import type { PulseState } from './pulseProvider';

export interface AdminState {
    chat: ChatState;
    pulse: PulseState;
    dashboard: DashboardState;
    modal: ModalState;
    liquidEngine: LiquidEngine;
}

// Keep the context identity outside the hot-updated provider/component graph.
// Type-only dependencies prevent modal consumers from creating a runtime cycle.
export const AdminContext = createContext<AdminState | null>(null);

export const useAdminContext = (): AdminState => {
    const context = useContext(AdminContext);
    if (!context) {
        throw new Error('useAdminContext must be used inside AdminProvider');
    }
    return context;
};
